/**
 * @param {URLSearchParams} params
 */
export function passengersFromParams(params) {
  let values = params.getAll('passenger')
  if (!values.length) return undefined

  const types = /** @type {(Schema.PassengerType | 'UNKNOWN')[]} */ ([
    'ADULT',
    'YOUTH',
    'SENIOR',
    'UNKNOWN'
  ])

  // Get passengers structs
  const passengers = values.reduce((acc, str) => {
    let [type, value] = str.split('.')

    if (type === 'UNKNOWN') {
      acc.push({ birthDate: value })
    } else {
      acc.push({
        type: /** @type {Schema.PassengerType} */ (type),
        age: value ? +value : undefined
      })
    }

    return acc
  }, /** @type {(Schema.PassengerPlaceholderInput|{ type: 'UNKNOWN', birthDate?: string })[]} */ ([]))

  // Assign ages per type
  for (const type of types.filter((type) => params.has(`${type}-age`))) {
    const ages = params.getAll(`${type}-age`).map(Number)
    const ofType = /** @type {Schema.PassengerPlaceholderInput[]} */ (
      passengers.filter((passenger) => passenger.type === type)
    )
    ages.forEach((age, index) => (ofType[index].age = age))
  }

  // Assign birth dates in order of appearance
  params.getAll('UNKNOWN-birthDate').forEach((birthDate, index) => {
    passengers[index].birthDate = birthDate
  })

  // Add or remove passengers
  for (const type of types.filter((type) => params.has(type))) {
    const value = +(/** @type {string} */ (params.get(type)))
    if (Number.isNaN(value)) continue
    const ofType = passengers.filter((passenger) => passenger.type === type)
    if (value > ofType.length) {
      passengers.push({ type })
    } else if (value < ofType.length) {
      for (let i = 0, len = ofType.length - value; i < len; i++) {
        passengers.splice(
          passengers.findLastIndex((passenger) => passenger.type === type),
          1
        )
      }
    }
  }

  return passengers.map((passenger) => {
    const { type } = passenger
    return { ...passenger, type: type === 'UNKNOWN' ? undefined : type }
  })
}

/**
 * @param {Schema.PassengerPlaceholderInput[]} passengers
 */
export function passengersToParams(passengers) {
  return passengers
    .map((passenger) => {
      const type = passenger.type || 'UNKNOWN'
      const value = passenger.age || passenger.birthDate
      return value ? `${type}.${value}` : type
    })
    .filter(Boolean)
}

/**
 * @param {{ type?: Schema.PassengerType? }[]} passengers
 */
export function getPassengersLabel(passengers) {
  const types = new Set(passengers.map((passenger) => passenger.type))
  return types.size > 1 || types.has(undefined) || types.has(null)
    ? 'people'
    : /** @type {Schema.PassengerType} */ (passengers[0].type)
}
